import React, { useEffect, useState } from "react";

const colorFor = (rating) => {
  if (rating === "red") return "#FF3B3B";
  if (rating === "yellow") return "#FFB800";
  return "#00C853";
};

export const ScoreGauge = ({ score = 0, rating = "green", size = 240 }) => {
  const [display, setDisplay] = useState(0);
  const color = colorFor(rating);
  const stroke = 10;
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const offset = circ - (display / 100) * circ;

  useEffect(() => {
    let start;
    let raf;
    const duration = 1400;
    const step = (ts) => {
      if (!start) start = ts;
      const p = Math.min(1, (ts - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(eased * score));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [score]);

  return (
    <div
      data-testid="score-gauge"
      className="relative flex items-center justify-center"
      style={{ width: size, height: size, filter: `drop-shadow(0 0 24px ${color}88)` }}
    >
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="rgba(255,255,255,0.06)"
          strokeWidth={stroke}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circ}
          strokeDashoffset={offset}
          style={{ transition: "stroke-dashoffset 0.08s linear" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="font-mono text-xs tracking-[0.3em] uppercase text-[color:var(--text-2)]">score</div>
        <div className="font-display text-[64px] leading-none font-bold" style={{ color }}>
          {display}
        </div>
        <div className="font-mono text-xs tracking-[0.25em] uppercase" style={{ color }}>
          / 100
        </div>
      </div>
    </div>
  );
};

export default ScoreGauge;
